// Module
var code = `{{#if tradingCentralTool}}
    <div class="js-tradingTools-container">
        <div class="js-tradingTools-tradingCentral" on-click="@this.tradingCentralLinkClick(this)"></div>
    </div>
{{/if}}
{{#if autochartistTool}}
    <div class="js-tradingTools-container">
        <div class="js-tradingTools-autochartist" on-click="@this.autochartistLinkClick(this)"></div>
    </div>
{{/if}}`;
// Exports
export default code;